export default "__VITE_ASSET__ALLRC9Ne__"